import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import getProcedureUIString, {ProceduresStringKeys, StringCase} from 'procedures/ProceduresStringKeys';

/**
 * Helper for assessing the validity of a method node name.
 *
 * Checks for empty name and duplicated name.
 *
 * @param methodName The name being validated
 * @param allMethodNamesExcludingSelectedMethod All other names in the flowchart
 * @returns string (if there is an error message to display) or null (if no error)
 */
export function validateMethodName(
  methodName: string,
  allMethodNamesExcludingSelectedMethod: Array<string>,
  procedureType: ProcedureType
): string | null {
  const errorObjectType = `${getProcedureUIString(ProceduresStringKeys.METHOD, procedureType, {
    stringCase: StringCase.SENTENCE,
  })}`;

  const name = methodName.trim();

  return name.length === 0
    ? `${errorObjectType} names are required`
    : allMethodNamesExcludingSelectedMethod.includes(name)
      ? `${errorObjectType} names must be unique`
      : null;
}
